import axios from "axios";
import { backendUri } from "@/utils/settings";

const getTrainerPokeInfo = async (id) => {
  const response = await axios.get(
    backendUri + "api/game/ext/trainer/pokemon/" + id + "/"
  );

  return response.data;
};

const wonderTrade = async (id) => {
  const response = await axios.post(
    backendUri + "api/game/ext/trainer/wonder-trade/" + id + "/"
  );

  return response.data;
};

const getUsableItems = async () => {
  const response = await axios.get(
    backendUri + "api/game/ext/trainer/inventory/?usable_on_pokemon=true"
  );

  return response.data;
};

const useItem = async (pokemonId, itemId) => {
  await axios.post(backendUri + "api/game/ext/trainer/use-item-on-pkm/", {
    pokemon_id: pokemonId,
    item_id: itemId,
  });
};

const removeFromTeam = async (pokemonId) => {
  await axios.post(backendUri + "api/game/ext/trainer/pokemon-remove-team/", {
    pokemon_id: pokemonId,
  });
};

const getPokedexInfo = async (pokemonId) => {
  return await axios.get(
    backendUri + "api/game/ext/trainer/pokedex/info/?pokedex_id=" + pokemonId
  );
};

export {
  getTrainerPokeInfo,
  wonderTrade,
  getUsableItems,
  useItem,
  removeFromTeam,
  getPokedexInfo
};
